import { implementsFunction } from "@thi.ng/checks";
export const ensureTransducer = (x) => implementsFunction(x, "xform") ? x.xform() : x;
